import {BaseModel} from '@/core/standard/BaseModel';
import ReportsServices from '@/modules/reports/ReportsServices';
import {BoxProtocol, IBoxes, IBoxModel} from '@/modules/reports/boxReport/IBoxModel';
import {SaleProtocol} from '@/modules/reports/salesReport/ISaleModel';

const box = {
  id: '',
  serial: '',
  created_at: '',
  updated_at: '',
  iva: '',
  total_general: '',
  total_local: '',
  total_recoger: '',
  total_domicilio: '',
  total_credit_card: '',
  total_cash: '',
  total_discounted: '',
  total_local_credit_card: '',
  total_recoger_credit_card: '',
  total_domicilio_credit_card: '',
  total_general_tips: '',
  base_imp: '',
  total_imp: '',
  initial_import: '',
  cash_register: '',
  unbalance: '',
  close_type: 'close_box',
  card_bank: '',
};

interface ReportRes {
  data: BoxProtocol[];
  last: IBoxModel;
  total: number;
  sum: number;
}

class BoxReportModel extends BaseModel<IBoxModel, BoxProtocol, typeof ReportsServices> {
  public modelName = 'Reporte de Caja';

  public request = 'JSON';

  constructor() {
    super(box, ReportsServices);
  }

  public async getAllBoxReports(protocol: BoxProtocol): Promise<ReportRes> {
    const response = await this.service.getAllBoxReports({method: 'POST', query: protocol});
    if (response && response.data) {
      return {
        data: response.data.results,
        last: response.data.last,
        total: response.data.total,
        sum: response.data.sum,
      };
    }
    return {data: [], last: {} as IBoxModel, total: 0, sum: 0};
  }

  public async closeBox(query, toast) {
    const res = await this.service.closeBox({query, method: 'POST'});
    if (res.complete) {
      (res.data === true) ? toast.success(res.message) : toast.success(res.data)
    } else {
      this.handleError(res, toast);
      return false;
    }
  }

  public async printBox(id, toast) {
    const res = await this.service.printBox({method: 'POST', query: {id}});
    if (res.complete) {
      if (res.data) {
        toast.success(res.message);
        return true;
      }
    } else {
      this.handleError(res, toast);
      return false;
    }
  }

  public async updateCashRegister(id, cashRegister, toast) {
    const res = await this.service.updateCashRegister({method: 'POST', query: {id, cash_register: cashRegister}});
    if (res.complete) {
      if (res.data) {
        toast.success(res.message);
        return true;
      }
    } else {
      this.handleError(res, toast);
      return false;
    }
  }

  public async getFile(protocol: SaleProtocol) {
    return await this.service.downloadBoxesFile({
      method: 'GET',
      query: protocol,
      headers: {Accept: '*/*'},
      responseType: 'blob',
    });
  }
}

// @ts-ignore
export default BoxReportModel as new () => IBoxes;
